/* ─── localization-popup.js ─────────────────────────────────────────────────
   Gestion de la popup de sélection langue / pays.
   Les données Shopify (locale courante, pays courant) sont injectées via
   window.LocalizationPopupConfig par la section localization-popup.liquid.
─────────────────────────────────────────────────────────────────────────── */

/* ── DEBUG — passer à false avant mise en production ── */
const LP_DEBUG = true;

function lpLog(...args) {
  if (LP_DEBUG) console.log('[LocalizationPopup]', ...args);
}

function initLocalizationPopup() {
  const config = window.LocalizationPopupConfig || {};
  const overlay = document.getElementById('localization-popup-overlay');

  if (!overlay) {
    lpLog('ERROR: #localization-popup-overlay introuvable dans le DOM');
    return;
  }

  const form = overlay.querySelector('form');
  const closeBtn = document.getElementById('localization-popup-close-btn');
  const countrySelect = form ? form.querySelector('select[name="country_code"]') : null;
  const localeSelect  = form ? form.querySelector('select[name="locale_code"]')  : null;

  lpLog('init — état courant', {
    currentCountry:     config.currentCountry,
    currentLanguage:    config.currentLanguage,
    availableCountries: config.availableCountries,
    availableLanguages: config.availableLanguages,
    countrySelectFound: !!countrySelect,
    localeSelectFound:  !!localeSelect,
  });

  /* ─── API publique ─── */
  window.LocalizationPopup = {
    open() {
      lpLog('open');
      overlay.style.display = '';
      document.body.style.overflow = 'hidden';
    },
    close() {
      lpLog('close');
      overlay.style.display = 'none';
      document.body.style.overflow = '';
    },
  };

  /* Fermeture : clic sur l'overlay (hors popup) */
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      lpLog('close — clic overlay');
      window.LocalizationPopup.close();
    }
  });

  /* Fermeture : bouton "Fermer" */
  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      lpLog('close — bouton Fermer');
      window.LocalizationPopup.close();
    });
  }

  /* Fermeture : touche Escape */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && overlay.style.display !== 'none') {
      lpLog('close — touche Escape');
      window.LocalizationPopup.close();
    }
  });

  /* Soumission : vider le panier si changement de pays (prix/dispo peuvent changer) */
  if (form) {
    form.addEventListener('submit', (e) => {
      const newCountry = countrySelect ? countrySelect.value : null;
      const newLocale  = localeSelect  ? localeSelect.value  : null;

      lpLog('submit', {
        newCountry,
        newLocale,
        curCountry:      config.currentCountry,
        curLanguage:     config.currentLanguage,
        countryChanged:  newCountry !== config.currentCountry,
        languageChanged: newLocale  !== config.currentLanguage,
      });

      if (newCountry && newCountry !== config.currentCountry) {
        lpLog('changement de pays détecté — vider le panier avant redirect');
        e.preventDefault();
        fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
        })
          .then(() => {
            lpLog('panier vidé — soumission form');
            form.submit();
          })
          .catch((err) => {
            lpLog('erreur clear cart (ignorée, submit quand même):', err);
            form.submit();
          });
      }
      /* Changement de langue seul → soumission native, Shopify redirige vers /{locale}/... */
    });
  }

  lpLog('prêt');
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLocalizationPopup);
} else {
  initLocalizationPopup();
}
